import { AgExpandCellRendererComponent } from 'components/AgGrid/AgExpandCellRendererComponent';
import type { ActKc2OtherPriceItem } from 'gql/graphql';
import { TYPE_CONST } from 'pages/Project/Common/AddWorkOrderOtherForm/helpers';
import { formatNumberToRu } from 'utils';

import type { ColDef, ColGroupDef, IRowNode } from 'ag-grid-community';
import { useMemo } from 'react';

interface IUseUerActKC2OtherPriceColumns {
    onExpandDetailsClick: (data?: ActKc2OtherPriceItem) => void;
}

export const useUerActKC2OtherPriceColumns = (props: IUseUerActKC2OtherPriceColumns) =>
    useMemo<ColDef<ActKc2OtherPriceItem>[] | ColGroupDef<ActKc2OtherPriceItem>[]>(
        () => [
            {
                width: 50,
                cellRenderer: AgExpandCellRendererComponent,
                cellRendererParams: {
                    onClick: props.onExpandDetailsClick,
                    isInvisible: (_: ActKc2OtherPriceItem, node: IRowNode<ActKc2OtherPriceItem>) => !node.rowPinned,
                },
            },
            {
                headerName: 'Наименование работ',
                field: 'name',
                flex: 1,
            },
            {
                headerName: 'Ед.изм.',
                field: 'calculatingTypeValue',
                width: 100,
                valueGetter: ({ data }) =>
                    (data?.calculatingType && TYPE_CONST[data.calculatingType]) ||
                    (data?.calculatingType && `${formatNumberToRu(data?.calculatingTypeValue, 2)} %`),
            },
            {
                headerName: 'Выполнено работ',
                width: 180,
                children: [
                    {
                        headerName: 'Стоимость, руб.',
                        field: 'costAccepted',
                        spanHeaderHeight: true,
                        cellClass: 'ag-right-aligned-cell',
                        valueFormatter: ({ data }) => formatNumberToRu(data?.costAccepted, 2),
                    },
                ],
            },
        ],
        [props.onExpandDetailsClick],
    );
